import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isEmpty } from "@duosoftbg/nacid-components";
import SitemapSubGroupDialogBody from "./SitemapSubGroupDialogBody";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { sitemapSection } from "../../../../../../utils/constants";
import { closeEditModal } from "../../../../../../store/redux/slice/ComponentsControl/sitemapControl";

const SitemapSubGroupDialog = () => {
  const dispatch = useAppDispatch();
  const { open, object } = useAppSelector((state) => {
    return state.ComponentsControl.sitemapControl.sections[sitemapSection.subGroup].modals.edit;
  });

  const handleCloseDialog = () => {
    dispatch(closeEditModal({ section: sitemapSection.subGroup }));
  };
  const { t } = useTranslation();
  const isEditMode = !isEmpty(object.id);

  return (
    <div>
      <Dialog
        PaperProps={{ sx: { position: "fixed", top: "10%", m: 0 } }}
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => handleCloseDialog()}
        aria-labelledby="sitemap-subgroup-dialog-title"
      >
        <DialogTitle id="sitemap-subgroup-dialog-title" style={{ textAlign: "center" }}>
          {!isEditMode && t("t.sitemap.subgroup.create.dialog")}
          {isEditMode && t("t.sitemap.subgroup.edit.dialog")}
        </DialogTitle>
        <DialogContent>
          <SitemapSubGroupDialogBody editingSubGroup={object} setOpen={handleCloseDialog} isEditMode={isEditMode} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SitemapSubGroupDialog;
